<template>
    <v-container
            id="dashboard"
            fluid
            tag="section"
    >
        <v-row>
            <v-col
                    cols="12"
                    md="6"
            >

                <h2 class="mb-2">{{ $t('dashboard.welcome') }}</h2>

                <v-btn
                        v-if="isSeller"
                        to="products/new"
                        color="primary"
                        dark
                        depressed
                >
                    {{ $t('global.add_pieces') }}
                </v-btn>
            </v-col>

            <v-col
                    cols="12"
                    md="6"
                    v-if="isSeller"
            >
                <NotificationsList/>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';
    import NotificationsList from './components/NotificationsList'

    export default {
        name: 'DashboardDashboard',

        data() {
            return {}
        },

        computed: {
            ...mapGetters(['isSeller']),
            ...mapState(['userInformation']),
        },
        components: {
            NotificationsList
        },
    }
</script>
